import axios from 'axios';
import actions from '../actions/language';

export default {
	namespaced: true,
	actions: {
		[actions.GET_LANGUAGES]: async ({ rootState }) => {
			let languages = [];

			try {
				const link = rootState.root.links.find(x => x.rel === 'languages');

				const response = await axios.get(link.href);

				const { data } = response;

				languages = data;
			} catch (error) {
				throw error;
			}

			return languages;
		},
	},
};
